import { fetchApi } from '@/services/api-client';

export type WalletTransactionType = 'topup' | 'purchase' | 'adjustment' | 'refund' | 'bonus';

export interface WalletTransactionItem {
  name: string;
  quantity: number;
  lineTotal: number;
}

export interface WalletTransaction {
  id: string;
  type: WalletTransactionType;
  /** Signed integer baht: positive = credit, negative = debit. */
  amount: number;
  note: string;
  orderId: string | null;
  /** What was bought, for a purchase; empty for every other type. */
  items: WalletTransactionItem[];
  createdAt: string;
}

export interface Wallet {
  balance: number;
  transactions: WalletTransaction[];
}

export interface TopUpInput {
  amount: number;
  /** Optional promotional free credit granted on top of `amount` (recorded as a separate bonus). */
  bonus?: number;
  note?: string;
}

const BASE = '/admin/cafeteria/wallet';

export const walletApi = {
  getWallet: (userId: string) => fetchApi<Wallet>(`${BASE}/${userId}`),

  /**
   * The caller's own wallet. A separate self-service endpoint, scoped server-side to the
   * authenticated user rather than a userId in the path, so it needs no cafeteria module.
   */
  getMyWallet: () => fetchApi<Wallet>('/me/cafeteria/wallet'),
  topUp: (userId: string, input: TopUpInput) =>
    fetchApi<{ balance: number }>(`${BASE}/${userId}/topup`, { method: 'POST', body: JSON.stringify(input) }),
};
